import factory from "codemirror-ssr";
import usePlaceholder from "codemirror-ssr/addon/display/placeholder.js";
import useContinuelist from "codemirror-ssr/addon/edit/continuelist.js";
import useOverlay from "codemirror-ssr/addon/mode/overlay.js";
import useGfm from "codemirror-ssr/mode/gfm/gfm.js";
import useMarkdown from "codemirror-ssr/mode/markdown/markdown.js";
import useXml from "codemirror-ssr/mode/xml/xml.js";
import useYamlFrontmatter from "codemirror-ssr/mode/yaml-frontmatter/yaml-frontmatter.js";
import useYaml from "codemirror-ssr/mode/yaml/yaml.js";
import selectFiles from "select-files";
import wordCount from "word-count";
import { delegate } from "tippy.js";
import { debounce } from "lodash-es";
const index = "";
function noop() {
}
function run(fn) {
  return fn();
}
function blank_object() {
  return /* @__PURE__ */ Object.create(null);
}
function run_all(fns) {
  fns.forEach(run);
}
function is_function(thing) {
  return typeof thing === "function";
}
function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || (a && typeof a === "object" || typeof a === "function");
}
function not_equal(a, b) {
  return a != a ? b == b : a !== b;
}
function is_empty(obj) {
  return Object.keys(obj).length === 0;
}
function append(target, node) {
  target.appendChild(node);
}
function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}
function detach(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}
function destroy_each(iterations, detaching) {
  for (let i = 0; i < iterations.length; i += 1) {
    if (iterations[i])
      iterations[i].d(detaching);
  }
}
function element(name) {
  return document.createElement(name);
}
function text(data) {
  return document.createTextNode(data);
}
function empty() {
  return text("");
}
function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return () => node.removeEventListener(event, handler, options);
}
function attr(node, attribute, value) {
  if (value == null)
    node.removeAttribute(attribute);
  else if (node.getAttribute(attribute) !== value)
    node.setAttribute(attribute, value);
}
function children(element2) {
  return Array.from(element2.childNodes);
}
function set_data(text2, data) {
  data = "" + data;
  if (text2.wholeText !== data)
    text2.data = data;
}
function toggle_class(element2, name, toggle) {
  element2.classList[toggle ? "add" : "remove"](name);
}
function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
  const e = document.createEvent("CustomEvent");
  e.initCustomEvent(type, bubbles, cancelable, detail);
  return e;
}
let current_component;
function set_current_component(component) {
  current_component = component;
}
function get_current_component() {
  if (!current_component)
    throw new Error("Function called outside component initialization");
  return current_component;
}
function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}
function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}
function createEventDispatcher() {
  const component = get_current_component();
  return (type, detail, { cancelable = false } = {}) => {
    const callbacks = component.$$.callbacks[type];
    if (callbacks) {
      const event = custom_event(type, detail, { cancelable });
      callbacks.slice().forEach((fn) => {
        fn.call(component, event);
      });
      return !event.defaultPrevented;
    }
    return true;
  };
}
const dirty_components = [];
const binding_callbacks = [];
const render_callbacks = [];
const flush_callbacks = [];
const resolved_promise = Promise.resolve();
let update_scheduled = false;
function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}
function tick() {
  schedule_update();
  return resolved_promise;
}
function add_render_callback(fn) {
  render_callbacks.push(fn);
}
const seen_callbacks = /* @__PURE__ */ new Set();
let flushidx = 0;
function flush() {
  const saved_component = current_component;
  do {
    while (flushidx < dirty_components.length) {
      const component = dirty_components[flushidx];
      flushidx++;
      set_current_component(component);
      update(component.$$);
    }
    set_current_component(null);
    dirty_components.length = 0;
    flushidx = 0;
    while (binding_callbacks.length)
      binding_callbacks.pop()();
    for (let i = 0; i < render_callbacks.length; i += 1) {
      const callback = render_callbacks[i];
      if (!seen_callbacks.has(callback)) {
        seen_callbacks.add(callback);
        callback();
      }
    }
    render_callbacks.length = 0;
  } while (dirty_components.length);
  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }
  update_scheduled = false;
  seen_callbacks.clear();
  set_current_component(saved_component);
}
function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    const dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}
const outroing = /* @__PURE__ */ new Set();
let outros;
function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}
function transition_out(block, local, detach2, callback) {
  if (block && block.o) {
    if (outroing.has(block))
      return;
    outroing.add(block);
    outros.c.push(() => {
      outroing.delete(block);
      if (callback) {
        if (detach2)
          block.d(1);
        callback();
      }
    });
    block.o(local);
  } else if (callback) {
    callback();
  }
}
function create_component(block) {
  block && block.c();
}
function mount_component(component, target, anchor, customElement) {
  const { fragment, after_update } = component.$$;
  fragment && fragment.m(target, anchor);
  if (!customElement) {
    add_render_callback(() => {
      const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
      if (component.$$.on_destroy) {
        component.$$.on_destroy.push(...new_on_destroy);
      } else {
        run_all(new_on_destroy);
      }
      component.$$.on_mount = [];
    });
  }
  after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
  const $$ = component.$$;
  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching);
    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}
function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }
  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function init(component, options, instance2, create_fragment2, not_equal2, props, append_styles, dirty = [-1]) {
  const parent_component = current_component;
  set_current_component(component);
  const $$ = component.$$ = {
    fragment: null,
    ctx: [],
    props,
    update: noop,
    not_equal: not_equal2,
    bound: blank_object(),
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
    callbacks: blank_object(),
    dirty,
    skip_bound: false,
    root: options.target || parent_component.$$.root
  };
  append_styles && append_styles($$.root);
  let ready = false;
  $$.ctx = instance2 ? instance2(component, options.props || {}, (i, ret, ...rest) => {
    const value = rest.length ? rest[0] : ret;
    if ($$.ctx && not_equal2($$.ctx[i], $$.ctx[i] = value)) {
      if (!$$.skip_bound && $$.bound[i])
        $$.bound[i](value);
      if (ready)
        make_dirty(component, i);
    }
    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update);
  $$.fragment = create_fragment2 ? create_fragment2($$.ctx) : false;
  if (options.target) {
    if (options.hydrate) {
      const nodes = children(options.target);
      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      $$.fragment && $$.fragment.c();
    }
    if (options.intro)
      transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor, options.customElement);
    flush();
  }
  set_current_component(parent_component);
}
class SvelteComponent {
  $destroy() {
    destroy_component(this, 1);
    this.$destroy = noop;
  }
  $on(type, callback) {
    if (!is_function(callback)) {
      return noop;
    }
    const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
    callbacks.push(callback);
    return () => {
      const index2 = callbacks.indexOf(callback);
      if (index2 !== -1)
        callbacks.splice(index2, 1);
    };
  }
  $set($$props) {
    if (this.$$set && !is_empty($$props)) {
      this.$$.skip_bound = true;
      this.$$set($$props);
      this.$$.skip_bound = false;
    }
  }
}
const bold = "Bold";
const boldText = "bold text";
const cheatsheet = "Markdown Cheatsheet";
const closeHelp = "Close help";
const closeToc = "Close table of contents";
const code = "Code";
const codeBlock = "Code block";
const codeLang = "lang";
const codeText = "code";
const exitFullscreen = "Exit fullscreen";
const exitPreviewOnly = "Exit preview only";
const exitWriteOnly = "Exit write only";
const fullscreen = "Fullscreen";
const h1 = "Heading 1";
const h2 = "Heading 2";
const h3 = "Heading 3";
const h4 = "Heading 4";
const h5 = "Heading 5";
const h6 = "Heading 6";
const headingText = "heading";
const help = "Help";
const hr = "Horizontal rule";
const image = "Image";
const imageAlt = "alt";
const imageTitle = "title";
const italic = "Italic";
const italicText = "italic text";
const limited = "The maximum character limit has been reached";
const lines = "Lines";
const link = "Link";
const linkText = "link text";
const ol = "Ordered list";
const olItem = "item";
const preview = "Preview";
const previewOnly = "Preview only";
const quote = "Quote";
const quotedText = "quoted text";
const shortcuts = "Shortcuts";
const source = "Source code";
const sync = "Scroll sync";
const toc = "Table of contents";
const top = "Scroll to top";
const ul = "Unordered list";
const ulItem = "item";
const words = "Words";
const write = "Write";
const writeOnly = "Write only";
const en = {
  bold,
  boldText,
  cheatsheet,
  closeHelp,
  closeToc,
  code,
  codeBlock,
  codeLang,
  codeText,
  exitFullscreen,
  exitPreviewOnly,
  exitWriteOnly,
  fullscreen,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  headingText,
  help,
  hr,
  image,
  imageAlt,
  imageTitle,
  italic,
  italicText,
  limited,
  lines,
  link,
  linkText,
  ol,
  olItem,
  preview,
  previewOnly,
  quote,
  quotedText,
  shortcuts,
  source,
  sync,
  toc,
  top,
  ul,
  ulItem,
  words,
  write,
  writeOnly
};
function createCodeMirror() {
  const codemirror = factory();
  usePlaceholder(codemirror);
  useOverlay(codemirror);
  useXml(codemirror);
  useMarkdown(codemirror);
  useGfm(codemirror);
  useYaml(codemirror);
  useYamlFrontmatter(codemirror);
  useContinuelist(codemirror);
  return codemirror;
}
function createEditorUtils(codemirror, editor) {
  return {
    wrapText(before, after = before) {
      const range = editor.somethingSelected() ? editor.listSelections()[0] : editor.findWordAt(editor.getCursor());
      const from = range.from();
      const to = range.to();
      const text2 = editor.getRange(from, to);
      const fromBefore = codemirror.Pos(from.line, from.ch - before.length);
      const toAfter = codemirror.Pos(to.line, to.ch + after.length);
      if (editor.getRange(fromBefore, from) === before && editor.getRange(to, toAfter) === after) {
        editor.replaceRange(text2, fromBefore, toAfter);
        editor.setSelection(
          fromBefore,
          codemirror.Pos(fromBefore.line, fromBefore.ch + text2.length)
        );
      } else {
        editor.replaceRange(before + text2 + after, from, to);
        const cursor = editor.getCursor();
        editor.setSelection(
          codemirror.Pos(cursor.line, cursor.ch - after.length - text2.length),
          codemirror.Pos(cursor.line, cursor.ch - after.length)
        );
      }
    },
    replaceLines(replace) {
      const [selection] = editor.listSelections();
      const range = [
        codemirror.Pos(selection.from().line, 0),
        codemirror.Pos(selection.to().line)
      ];
      const lines2 = editor.getRange(...range).split("\n");
      editor.replaceRange(lines2.map(replace).join("\n"), ...range);
      editor.setSelection(...range);
    },
    appendBlock(content) {
      const cursor = editor.getCursor();
      let emptyLine = -1;
      for (let i = cursor.line; i < editor.lineCount(); i++) {
        if (!editor.getLine(i).trim()) {
          emptyLine = i;
          break;
        }
      }
      if (emptyLine === -1) {
        editor.replaceRange("\n", codemirror.Pos(editor.lineCount()));
        emptyLine = editor.lineCount();
      }
      editor.replaceRange("\n" + content, codemirror.Pos(emptyLine));
      return codemirror.Pos(emptyLine + 1, 0);
    },
    selectFiles
  };
}
function findStartIndex(num, nums) {
  let startIndex = nums.length - 2;
  for (let i = 0; i < nums.length; i++) {
    if (num < nums[i]) {
      startIndex = i - 1;
      break;
    }
  }
  startIndex = Math.max(startIndex, 0);
  return startIndex;
}
const getShortcutWithPrefix = (key, shift = false) => {
  const shiftPrefix = shift ? "Shift-" : "";
  const CmdPrefix = typeof navigator !== "undefined" && /Mac/.test(navigator.platform) ? "Cmd-" : "Ctrl-";
  return shiftPrefix + CmdPrefix + key;
};
async function handleImageUpload({ editor, appendBlock, codemirror }, uploadImages, files) {
  const imgs = await uploadImages(files);
  const pos = appendBlock(
    imgs.map(({ url, alt, title }, i) => {
      alt = alt != null ? alt : files[i].name;
      return `![${alt}](${url}${title ? ` "${title}"` : ""})`;
    }).join("\n\n")
  );
  editor.setSelection(pos, codemirror.Pos(pos.line + imgs.length * 2 - 2));
  editor.focus();
}
function getBuiltinActions(locale, plugins, uploadImages) {
  const leftActions = [
    {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
        <path d="M2.33333 1.75C2.01117 1.75 1.75 2.01117 1.75 2.33333C1.75 2.6555 2.01117 2.91667 2.33333 2.91667H2.91667V11.0833H2.33333C2.01117 11.0833 1.75 11.3445 1.75 11.6667C1.75 11.9888 2.01117 12.25 2.33333 12.25H4.66667C4.98883 12.25 5.25 11.9888 5.25 11.6667C5.25 11.3445 4.98883 11.0833 4.66667 11.0833H4.08333V7.58333L9.91667 7.58333V11.0833H9.33333C9.01117 11.0833 8.75 11.3445 8.75 11.6667C8.75 11.9888 9.01117 12.25 9.33333 12.25H11.6667C11.9888 12.25 12.25 11.9888 12.25 11.6667C12.25 11.3445 11.9888 11.0833 11.6667 11.0833H11.0833V2.91667H11.6667C11.9888 2.91667 12.25 2.6555 12.25 2.33333C12.25 2.01117 11.9888 1.75 11.6667 1.75H9.33333C9.01117 1.75 8.75 2.01117 8.75 2.33333C8.75 2.6555 9.01117 2.91667 9.33333 2.91667H9.91667V6.41667L4.08333 6.41667V2.91667H4.66667C4.98883 2.91667 5.25 2.6555 5.25 2.33333C5.25 2.01117 4.98883 1.75 4.66667 1.75H2.33333Z" fill="currentColor"/>
      </svg>`,
      handler: {
        type: "dropdown",
        actions: [1, 2, 3, 4, 5, 6].map((level) => ({
          title: locale[`h${level}`],
          icon: [
            `
              <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M25 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M6 24H25" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M34.2261 24L39.0001 19.0166V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            `,
            `
              <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M24 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7 24H23" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M32 25C32 21.8334 34.6667 20 37 20C39.3334 20 42 21.8334 42 25C42 30.7 32 34.9333 32 40H42" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            `,
            `
              <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M24 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7 24H23" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M32 20H42L35 29C39 29 42 31 42 35C42 39 39 40 37 40C34.619 40 33 39 32 37.9" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            `,
            `
              <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M24 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7 24H23" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M39.9767 40V20L31 32.9967V35.0199H43" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            `,
            `
              <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M24 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7 24H23" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M40 21.0093H32V28.0341C32 28 34 27 37 27C40 27 41 29.5339 41 33.5C41 37.4661 40 40 36 40C33 40 32 38 32 36.0078" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            `,
            `
              <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M24 8V40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M7 24H23" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M36.5 40C39.5376 40 42 37.5376 42 34.5C42 31.4624 39.5376 29 36.5 29C33.4624 29 31 31.4624 31 34.5C31 37.5376 33.4624 40 36.5 40Z" stroke="currentColor" stroke-width="4"></path>
                <path d="M41.5962 24.7392C40.7778 22.5461 38.8044 21 36.5 21C33.4624 21 31 23.6863 31 27V34" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            `
          ][level - 1],
          cheatsheet: level <= 3 ? `${"#".repeat(level)} ${locale.headingText}` : void 0,
          handler: {
            type: "action",
            click({ replaceLines, editor }) {
              replaceLines((line) => {
                line = line.trim().replace(/^#*/, "").trim();
                line = "#".repeat(level) + " " + line;
                return line;
              });
              editor.focus();
            }
          }
        }))
      }
    },
    {
      title: locale.bold,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.91699 2.33333C2.91699 2.01117 3.17816 1.75 3.50033 1.75H8.16699C9.77782 1.75 11.0837 3.05584 11.0837 4.66667C11.0837 5.50125 10.7331 6.25396 10.1713 6.7856C11.0636 7.28437 11.667 8.23839 11.667 9.33333C11.667 10.9442 10.3612 12.25 8.75033 12.25H3.50033C3.17816 12.25 2.91699 11.9888 2.91699 11.6667V2.33333ZM4.08366 7.58333V11.0833H8.75033C9.71682 11.0833 10.5003 10.2998 10.5003 9.33333C10.5003 8.36683 9.71682 7.58333 8.75033 7.58333H4.08366ZM4.08366 6.41667H8.16699C9.13349 6.41667 9.91699 5.63316 9.91699 4.66667C9.91699 3.70017 9.13349 2.91667 8.16699 2.91667H4.08366V6.41667Z" fill="currentColor"/>
</svg>`,
      cheatsheet: `**${locale.boldText}**`,
      handler: {
        type: "action",
        shortcut: getShortcutWithPrefix("B"),
        click({ wrapText, editor }) {
          wrapText("**");
          editor.focus();
        }
      }
    },
    {
      title: locale.italic,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
  <path d="M8.73623 1.75004H5.83301C5.51084 1.75004 5.24967 2.0112 5.24967 2.33337C5.24967 2.65554 5.51084 2.9167 5.83301 2.9167H7.90793L4.84542 11.0834H2.91634C2.59418 11.0834 2.33301 11.3445 2.33301 11.6667C2.33301 11.9889 2.59418 12.25 2.91634 12.25H5.23606C5.2451 12.2502 5.25412 12.2502 5.26311 12.25H8.16634C8.48851 12.25 8.74967 11.9889 8.74967 11.6667C8.74967 11.3445 8.48851 11.0834 8.16634 11.0834H6.09143L9.15392 2.9167H11.083C11.4052 2.9167 11.6663 2.65554 11.6663 2.33337C11.6663 2.0112 11.4052 1.75004 11.083 1.75004H8.76329C8.75425 1.74982 8.74523 1.74983 8.73623 1.75004Z" fill="currentColor"/>
</svg>`,
      cheatsheet: `*${locale.italicText}*`,
      handler: {
        type: "action",
        click({ wrapText, editor }) {
          wrapText("*");
          editor.focus();
        }
      }
    },
    {
      title: locale.quote,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.91634 4.66667C9.27201 4.66667 8.74967 5.189 8.74967 5.83333V6.41667L10.4997 6.41667C11.144 6.41667 11.6663 6.939 11.6663 7.58333V9.33333C11.6663 9.97767 11.144 10.5 10.4997 10.5H8.74967C8.10534 10.5 7.58301 9.97767 7.58301 9.33333V5.83333C7.58301 4.54467 8.62768 3.5 9.91634 3.5C10.2385 3.5 10.4997 3.76117 10.4997 4.08333C10.4997 4.4055 10.2385 4.66667 9.91634 4.66667ZM8.74967 9.33333V7.58333L10.4997 7.58333V9.33333H8.74967Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.33301 5.83333C2.33301 4.54467 3.37768 3.5 4.66634 3.5C4.98851 3.5 5.24968 3.76117 5.24968 4.08333C5.24968 4.4055 4.98851 4.66667 4.66634 4.66667C4.02201 4.66667 3.49967 5.189 3.49967 5.83333V6.41667L5.24968 6.41667C5.89401 6.41667 6.41634 6.939 6.41634 7.58333L6.41634 9.33333C6.41634 9.97767 5.89401 10.5 5.24967 10.5H3.49967C2.85534 10.5 2.33301 9.97767 2.33301 9.33333V5.83333ZM3.49967 9.33333L3.49967 7.58333L5.24968 7.58333L5.24967 9.33333H3.49967Z" fill="currentColor"/>
</svg>`,
      cheatsheet: `> ${locale.quotedText}`,
      handler: {
        type: "action",
        click({ replaceLines, editor }) {
          replaceLines((line) => "> " + line);
          editor.focus();
        }
      }
    },
    {
      title: locale.link,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M11.95 2.05027C10.5832 0.683437 8.36712 0.683438 7.00028 2.05027L6.17532 2.87523C5.94752 3.10304 5.94752 3.47238 6.17532 3.70019C6.40313 3.92799 6.77247 3.92799 7.00028 3.70019L7.82524 2.87523C8.73646 1.96401 10.2138 1.96401 11.1251 2.87523C12.0363 3.78645 12.0363 5.26384 11.1251 6.17506L10.3001 7.00002C10.0723 7.22783 10.0723 7.59717 10.3001 7.82498C10.5279 8.05278 10.8973 8.05278 11.1251 7.82498L11.95 7.00002C13.3169 5.63319 13.3169 3.41711 11.95 2.05027Z" fill="currentColor"/>
  <path d="M9.45442 4.54588C9.68222 4.77369 9.68222 5.14303 9.45442 5.37084L5.37108 9.45417C5.14328 9.68198 4.77393 9.68198 4.54613 9.45417C4.31832 9.22637 4.31832 8.85702 4.54613 8.62921L8.62946 4.54588C8.85727 4.31808 9.22661 4.31808 9.45442 4.54588Z" fill="currentColor" />
  <path d="M3.70043 6.17511C3.92824 6.40292 3.92824 6.77227 3.70043 7.00007L2.87548 7.82503C1.96425 8.73625 1.96425 10.2136 2.87547 11.1249C3.7867 12.0361 5.26408 12.0361 6.17531 11.1249L7.00026 10.2999C7.22807 10.0721 7.59742 10.0721 7.82522 10.2999C8.05303 10.5277 8.05303 10.8971 7.82522 11.1249L7.00026 11.9498C5.63343 13.3167 3.41735 13.3167 2.05052 11.9498C0.683682 10.583 0.683682 8.36691 2.05052 7.00007L2.87548 6.17511C3.10328 5.94731 3.47263 5.94731 3.70043 6.17511Z" fill="currentColor" />
</svg>`,
      cheatsheet: `[${locale.linkText}](url)`,
      handler: {
        type: "action",
        shortcut: getShortcutWithPrefix("K"),
        click({ editor, wrapText, codemirror }) {
          wrapText("[", "](url)");
          const cursor = editor.getCursor();
          editor.setSelection(
            codemirror.Pos(cursor.line, cursor.ch + 2),
            codemirror.Pos(cursor.line, cursor.ch + 5)
          );
          editor.focus();
        }
      }
    },
    {
      title: locale.image,
      icon: `<svg width="16" height="16" viewBox="0 0 1280 1280" xmlns="http://www.w3.org/2000/svg"><path d="M474.000 53.981 C 378.663 55.431,333.712 59.991,290.000 72.646 C 191.333 101.212,101.252 191.183,72.605 289.775 C 62.801 323.517,57.878 359.776,54.787 421.000 C 52.950 457.404,52.950 822.596,54.787 859.000 C 57.878 920.224,62.801 956.483,72.605 990.225 C 96.095 1071.068,161.511 1147.654,241.845 1188.361 C 283.390 1209.413,327.559 1219.449,398.627 1223.986 C 431.386 1226.077,503.046 1226.960,640.000 1226.960 C 849.747 1226.960,894.795 1225.482,947.000 1216.890 C 991.623 1209.545,1023.443 1198.161,1058.728 1176.916 C 1115.532 1142.716,1161.559 1092.620,1190.496 1033.500 C 1210.136 993.373,1219.700 949.681,1223.995 880.464 C 1226.072 846.987,1226.952 775.440,1226.952 640.000 C 1226.952 504.560,1226.072 433.013,1223.995 399.536 C 1219.700 330.319,1210.136 286.627,1190.496 246.500 C 1162.197 188.683,1117.605 139.538,1062.587 105.531 C 1006.991 71.166,958.680 59.428,854.500 54.972 C 824.125 53.672,542.492 52.939,474.000 53.981 M862.000 161.905 C 929.063 165.672,959.984 171.781,990.500 187.290 C 1034.686 209.747,1071.741 247.399,1094.514 292.979 C 1108.497 320.966,1114.536 353.971,1118.212 422.500 C 1120.067 457.062,1120.053 821.906,1118.196 857.500 C 1116.370 892.503,1112.697 930.017,1111.098 929.990 C 1110.769 929.984,1081.700 904.050,1046.500 872.358 C 1011.300 840.666,979.299 812.117,975.388 808.916 C 949.753 787.941,915.985 771.939,884.000 765.609 C 867.986 762.440,858.796 761.614,840.000 761.654 C 811.255 761.715,788.004 766.048,762.723 776.056 C 744.829 783.140,733.713 789.478,706.463 808.138 C 685.177 822.713,668.515 824.621,648.000 814.833 L 639.500 810.778 516.500 688.013 C 437.355 609.020,390.826 563.305,386.000 559.796 C 352.140 535.177,314.679 523.646,274.000 525.320 C 233.815 526.974,198.163 540.668,167.775 566.121 L 160.500 572.214 160.197 535.857 C 159.866 496.055,161.406 421.626,163.018 399.500 C 167.164 342.607,174.101 312.795,189.780 284.500 C 211.749 244.850,242.805 213.388,281.737 191.341 C 315.417 172.267,349.667 165.104,422.000 162.007 C 460.589 160.355,463.310 160.338,659.000 160.553 C 781.675 160.688,848.220 161.131,862.000 161.905 M838.694 291.060 C 783.385 295.968,734.632 329.738,709.040 380.867 C 705.121 388.696,698.671 407.909,696.573 418.000 C 689.385 452.575,694.257 489.773,710.104 521.303 C 732.528 565.922,772.294 596.514,821.660 607.123 C 836.855 610.388,862.779 610.855,878.650 608.148 C 913.266 602.246,941.356 587.754,966.055 563.055 C 989.109 540.000,1002.006 516.634,1009.690 484.000 C 1013.146 469.321,1014.008 442.338,1011.528 426.500 C 999.969 352.685,940.406 297.150,866.200 291.001 C 853.253 289.928,851.406 289.932,838.694 291.060 M863.566 398.076 C 882.895 401.580,900.138 417.987,904.904 437.409 C 906.795 445.115,906.399 458.497,904.056 466.085 C 900.459 477.728,891.548 489.022,880.500 495.941 C 857.416 510.396,824.584 503.159,809.389 480.267 C 795.034 458.640,797.648 431.145,815.782 413.011 C 828.861 399.932,845.360 394.775,863.566 398.076 M298.244 633.935 C 306.732 636.105,314.096 639.543,321.500 644.790 C 324.250 646.738,381.400 703.081,448.500 769.996 C 522.622 843.913,573.247 893.643,577.500 896.714 C 605.220 916.733,637.263 927.124,671.500 927.196 C 687.672 927.231,697.111 926.032,712.516 921.989 C 733.428 916.501,748.014 909.322,771.500 892.960 C 779.200 887.595,789.100 881.406,793.500 879.205 C 829.440 861.231,873.075 865.218,904.987 889.391 C 908.697 892.201,946.189 925.521,988.302 963.435 C 1053.500 1022.132,1064.730 1032.635,1063.917 1034.155 C 1061.960 1037.811,1039.151 1059.974,1029.497 1067.599 C 981.852 1105.233,943.144 1115.646,838.500 1118.981 C 798.492 1120.256,481.918 1120.270,442.000 1118.998 C 351.899 1116.127,314.195 1108.502,276.000 1085.426 C 227.127 1055.898,188.807 1007.970,174.519 958.500 C 164.336 923.245,160.055 862.849,160.015 753.912 L 160.000 714.324 199.970 679.414 C 243.122 641.724,248.474 637.878,263.090 634.051 C 273.174 631.410,288.179 631.360,298.244 633.935 " stroke="none" fill="currentColor" fill-rule="evenodd"/></svg>
      `,
      cheatsheet: `![${locale.imageAlt}](url "${locale.imageTitle}")`,
      handler: uploadImages ? {
        type: "action",
        shortcut: getShortcutWithPrefix("I", true),
        async click(ctx) {
          const fileList = await selectFiles({
            accept: "image/*",
            multiple: true
          });
          if (fileList == null ? void 0 : fileList.length) {
            await handleImageUpload(ctx, uploadImages, Array.from(fileList));
          }
        }
      } : void 0
    },
    {
      title: locale.code,
      icon: `
      <svg width="16" height="16" viewBox="0 0 1280 1280" xmlns="http://www.w3.org/2000/svg"><path d="M733.275 108.477 C 718.720 112.569,704.724 123.955,698.870 136.464 C 696.295 141.967,677.050 227.266,587.786 628.810 C 481.403 1107.369,479.824 1114.625,480.301 1123.000 C 481.928 1151.608,504.727 1172.946,533.712 1172.988 C 548.745 1173.010,562.438 1166.866,572.921 1155.396 C 583.180 1144.171,573.972 1183.037,691.740 653.856 C 796.167 184.619,799.310 170.193,799.357 160.000 C 799.396 151.562,798.962 148.246,797.146 143.113 C 791.617 127.484,779.605 115.291,764.348 109.821 C 756.698 107.077,740.712 106.386,733.275 108.477 M361.263 321.447 C 346.469 324.820,354.644 317.225,204.139 467.422 C 113.099 558.276,64.436 607.538,61.855 611.458 C 50.740 628.337,50.740 651.663,61.855 668.542 C 64.433 672.457,113.228 721.880,204.139 812.658 C 327.714 936.050,343.167 951.147,348.740 953.917 C 382.430 970.663,420.887 950.432,426.153 913.191 C 427.565 903.210,425.641 892.791,420.394 882.000 C 416.856 874.724,413.255 871.004,299.646 757.250 L 182.544 640.000 299.646 522.750 C 413.255 408.996,416.856 405.276,420.394 398.000 C 429.598 379.070,428.529 360.603,417.224 343.249 C 405.919 325.894,382.233 316.666,361.263 321.447 M896.500 320.950 C 874.549 325.691,858.592 342.014,854.222 364.198 C 852.010 375.425,853.456 385.133,859.092 396.892 L 863.218 405.500 980.337 522.750 L 1097.456 640.000 980.337 757.250 L 863.218 874.500 859.092 883.108 C 853.456 894.867,852.010 904.575,854.222 915.802 C 860.239 946.343,889.159 965.474,918.760 958.494 C 934.072 954.884,924.870 963.426,1075.861 812.658 C 1166.288 722.363,1215.574 672.446,1218.126 668.572 C 1228.287 653.143,1229.317 633.519,1220.887 616.000 C 1217.998 609.996,1207.156 598.887,1078.803 470.415 C 980.875 372.396,938.208 330.337,934.300 327.968 C 931.249 326.119,926.246 323.760,923.182 322.726 C 916.895 320.603,902.532 319.647,896.500 320.950 " stroke="none" fill="currentColor" fill-rule="evenodd"/></svg>
      `,
      cheatsheet: "`" + locale.codeText + "`",
      handler: {
        type: "action",
        shortcut: getShortcutWithPrefix("K", true),
        click({ wrapText, editor }) {
          wrapText("`");
          editor.focus();
        }
      }
    },
    {
      title: locale.codeBlock,
      icon: `<svg width="16" height="16" viewBox="0 0 1280 1280" xmlns="http://www.w3.org/2000/svg"><path d="M270.500 161.100 C 196.182 168.847,133.231 225.858,118.029 299.186 C 114.252 317.407,114.000 326.410,114.000 443.315 L 114.000 557.418 88.145 583.459 C 59.763 612.044,57.555 615.068,54.511 629.500 C 52.661 638.273,52.661 641.727,54.511 650.500 C 57.555 664.932,59.763 667.956,88.145 696.541 L 114.000 722.582 114.000 836.685 C 114.000 909.069,114.384 954.574,115.049 961.144 C 123.492 1044.483,187.497 1109.444,270.541 1118.957 C 290.150 1121.204,300.755 1120.058,312.667 1114.406 C 345.609 1098.775,353.004 1054.956,327.065 1029.078 C 317.274 1019.309,305.930 1014.612,289.279 1013.432 C 271.658 1012.182,259.830 1008.009,247.493 998.689 C 236.900 990.686,228.882 979.254,224.215 965.500 L 221.500 957.500 220.974 824.000 C 220.553 717.098,220.185 689.703,219.126 686.500 C 215.601 675.838,210.665 668.767,196.678 654.344 L 182.769 640.000 196.678 625.656 C 210.665 611.233,215.601 604.162,219.126 593.500 C 220.185 590.297,220.553 562.902,220.974 456.000 L 221.500 322.500 224.215 314.500 C 228.875 300.766,236.867 289.362,247.500 281.275 C 259.116 272.440,274.053 267.058,287.066 267.017 C 296.120 266.989,303.973 265.115,312.805 260.876 C 341.697 247.008,351.547 211.345,334.026 184.041 C 327.029 173.136,312.432 163.408,299.566 161.076 C 292.865 159.861,282.304 159.870,270.500 161.100 M979.500 161.098 C 970.473 162.937,960.090 168.717,952.904 175.904 C 934.670 194.137,932.018 221.615,946.400 243.283 C 956.040 257.806,973.699 266.891,992.500 267.000 C 1020.738 267.163,1046.605 286.871,1056.159 315.500 L 1058.495 322.500 1058.998 456.000 L 1059.500 589.500 1061.814 596.000 C 1065.268 605.701,1069.960 612.108,1084.336 626.750 L 1097.346 640.000 1084.347 653.250 C 1069.649 668.232,1064.924 674.656,1061.725 684.000 L 1059.500 690.500 1058.998 824.000 L 1058.495 957.500 1056.159 964.500 C 1050.143 982.527,1038.032 997.032,1022.000 1005.410 C 1012.993 1010.117,1006.298 1011.914,993.500 1013.059 C 978.881 1014.368,973.755 1015.591,966.000 1019.625 C 949.295 1028.315,938.917 1043.855,937.337 1062.546 C 935.137 1088.572,953.959 1113.554,979.799 1118.903 C 994.809 1122.010,1021.705 1118.745,1045.500 1110.926 C 1070.421 1102.738,1091.874 1089.731,1111.349 1071.000 C 1135.965 1047.325,1151.706 1020.686,1159.921 988.798 C 1165.527 967.036,1165.352 971.440,1165.728 842.503 L 1166.077 722.505 1191.894 696.503 C 1213.997 674.241,1218.164 669.565,1220.862 664.000 C 1224.124 657.272,1226.965 646.097,1226.965 640.000 C 1226.965 633.903,1224.124 622.728,1220.862 616.000 C 1218.164 610.434,1213.994 605.757,1191.855 583.459 L 1166.000 557.418 1166.000 443.815 C 1166.000 327.098,1165.741 317.949,1161.910 299.601 C 1147.302 229.625,1090.947 174.921,1021.111 162.924 C 1007.427 160.573,986.569 159.658,979.500 161.098 " stroke="none" fill="currentColor" fill-rule="evenodd"/></svg>
      `,
      cheatsheet: "```" + locale.codeLang + "\u21B5",
      handler: {
        type: "action",
        shortcut: getShortcutWithPrefix("C", true),
        click({ editor, appendBlock, codemirror }) {
          const pos = appendBlock("```js\n```");
          editor.setSelection(
            codemirror.Pos(pos.line, 3),
            codemirror.Pos(pos.line, 5)
          );
          editor.focus();
        }
      }
    },
    {
      title: locale.ul,
      icon: `
      <svg width="16" height="16" viewBox="0 0 1280 1280" xmlns="http://www.w3.org/2000/svg"><path d="M222.500 188.657 C 214.682 190.326,201.657 196.082,194.327 201.108 C 174.469 214.722,161.885 237.136,160.304 261.706 C 158.120 295.649,178.357 327.875,209.842 340.592 C 220.782 345.011,227.861 346.366,240.000 346.366 C 261.427 346.366,279.027 339.357,294.758 324.557 C 331.616 289.882,327.177 229.564,285.673 201.108 C 278.054 195.884,265.190 190.305,256.792 188.581 C 247.294 186.633,231.826 186.667,222.500 188.657 M473.000 214.054 C 429.762 219.320,411.380 273.346,442.374 304.068 C 449.767 311.395,456.973 315.563,466.428 317.982 C 474.258 319.984,476.663 320.000,773.410 319.985 C 1033.577 319.972,1073.315 319.778,1078.760 318.494 C 1098.041 313.949,1113.949 298.041,1118.494 278.760 C 1125.732 248.064,1104.315 217.592,1072.971 213.989 C 1062.710 212.809,482.704 212.873,473.000 214.054 M227.000 561.132 C 198.502 565.785,174.113 586.293,164.560 613.635 C 155.380 639.912,160.497 668.787,178.208 690.654 C 187.811 702.509,201.160 711.435,217.000 716.593 C 224.695 719.099,226.873 719.361,240.000 719.361 C 253.127 719.361,255.305 719.099,263.000 716.593 C 289.507 707.961,307.961 689.507,316.593 663.000 C 319.099 655.305,319.361 653.127,319.361 640.000 C 319.361 626.873,319.099 624.695,316.593 617.000 C 303.876 577.947,266.553 554.673,227.000 561.132 M466.112 588.576 C 448.600 593.299,433.873 607.963,428.595 625.932 C 427.638 629.190,427.010 634.991,427.026 640.432 C 427.093 664.095,442.108 684.111,465.000 691.056 C 471.416 693.002,475.426 693.024,775.000 692.764 L 1078.500 692.500 1084.348 690.291 C 1099.910 684.414,1112.004 672.097,1117.040 657.000 C 1126.209 629.507,1111.976 600.127,1084.461 589.748 L 1078.500 587.500 775.000 587.312 C 512.305 587.149,470.776 587.319,466.112 588.576 M231.273 934.062 C 212.403 935.965,194.884 944.817,181.346 959.289 C 166.430 975.234,158.893 996.370,160.304 1018.294 C 162.407 1050.981,183.363 1078.288,214.618 1089.068 C 224.204 1092.375,224.964 1092.477,240.000 1092.477 C 255.036 1092.477,255.796 1092.375,265.382 1089.068 C 280.946 1083.700,294.162 1074.210,303.649 1061.590 C 313.290 1048.764,318.669 1034.251,319.696 1018.294 C 322.868 969.002,280.933 929.055,231.273 934.062 M468.276 961.511 C 449.754 965.536,433.256 981.382,428.575 999.644 C 420.967 1029.325,439.515 1059.166,469.500 1065.489 C 479.920 1067.687,1066.922 1067.723,1077.287 1065.527 C 1106.644 1059.307,1125.317 1030.175,1118.494 1001.240 C 1115.129 986.966,1104.298 973.016,1091.270 966.175 C 1078.746 959.599,1101.239 960.029,773.000 960.097 C 526.051 960.148,473.425 960.393,468.276 961.511 " stroke="none" fill="currentColor" fill-rule="evenodd"/></svg>
      `,
      cheatsheet: `- ${locale.ulItem}`,
      handler: {
        type: "action",
        shortcut: getShortcutWithPrefix("U", true),
        click({ replaceLines, editor }) {
          replaceLines((line) => "- " + line);
          editor.focus();
        }
      }
    },
    {
      title: locale.ol,
      icon: `
      <svg width="16" height="16" viewBox="0 0 1280 1280" xmlns="http://www.w3.org/2000/svg"><path d="M266.112 108.581 C 252.641 112.203,252.960 111.923,183.440 181.220 C 138.073 226.441,117.341 247.784,114.951 251.728 C 109.400 260.887,107.056 269.123,107.026 279.568 C 106.983 294.725,111.983 306.983,122.500 317.500 C 132.896 327.896,145.270 333.000,160.076 333.000 C 178.494 333.000,187.196 328.180,210.250 305.211 L 227.000 288.522 227.000 408.051 C 227.000 512.155,227.198 528.338,228.531 533.458 C 233.247 551.565,248.435 566.753,266.542 571.469 C 269.775 572.311,276.263 572.988,280.960 572.974 C 303.999 572.905,324.049 557.757,331.036 535.145 C 332.959 528.924,333.000 524.802,333.000 340.076 C 333.000 169.395,332.846 150.844,331.388 145.932 C 325.886 127.398,311.524 113.237,293.458 108.531 C 286.174 106.634,273.264 106.657,266.112 108.581 M566.112 228.581 C 548.335 233.361,533.188 248.661,528.531 266.542 C 525.288 278.993,527.087 293.715,533.281 305.418 C 537.399 313.198,546.802 322.601,554.582 326.719 C 567.404 333.506,543.567 333.000,850.605 333.000 C 1124.250 333.000,1128.893 332.968,1135.145 331.036 C 1157.994 323.976,1172.907 304.027,1172.974 280.432 C 1173.003 270.329,1171.432 263.786,1166.749 254.500 C 1162.972 247.009,1153.466 237.560,1145.403 233.281 C 1132.609 226.492,1156.455 226.993,849.540 227.066 C 610.040 227.122,570.753 227.332,566.112 228.581 M566.112 588.581 C 548.335 593.361,533.188 608.661,528.531 626.542 C 525.288 638.993,527.087 653.715,533.281 665.418 C 537.399 673.198,546.802 682.601,554.582 686.719 C 567.404 693.506,543.567 693.000,850.605 693.000 C 1124.250 693.000,1128.893 692.968,1135.145 691.036 C 1157.994 683.976,1172.907 664.027,1172.974 640.432 C 1173.003 630.329,1171.432 623.786,1166.749 614.500 C 1162.972 607.009,1153.466 597.560,1145.403 593.281 C 1132.609 586.492,1156.455 586.993,849.540 587.066 C 610.040 587.122,570.753 587.332,566.112 588.581 M255.438 708.538 C 173.299 720.532,110.693 789.208,107.336 871.000 C 106.635 888.074,107.581 893.895,112.730 904.188 C 126.345 931.403,161.123 941.302,187.500 925.472 C 195.214 920.842,199.340 916.908,204.098 909.646 C 210.035 900.586,212.033 894.082,213.514 879.000 C 215.060 863.262,217.254 855.556,222.887 846.073 C 235.005 825.675,256.198 813.805,280.329 813.898 C 314.808 814.032,341.959 838.305,345.993 872.601 C 346.898 880.293,346.840 880.669,343.795 886.959 C 341.263 892.190,337.326 896.829,323.084 911.365 C 307.560 927.210,294.655 938.357,212.926 1006.516 C 113.311 1089.593,115.374 1087.685,109.905 1101.764 C 106.816 1109.715,106.114 1125.423,108.480 1133.620 C 113.836 1152.174,128.519 1166.774,146.542 1171.469 C 151.675 1172.806,168.708 1172.997,280.960 1172.974 L 409.500 1172.948 416.058 1170.713 C 438.941 1162.912,453.000 1143.641,453.000 1120.076 C 453.000 1097.319,440.079 1078.638,418.236 1069.816 C 412.554 1067.522,412.003 1067.495,360.048 1067.000 L 307.596 1066.500 342.548 1037.367 C 395.675 993.085,425.380 961.857,438.818 936.160 C 445.064 924.217,450.461 908.311,452.067 897.117 C 453.906 884.292,452.710 858.230,449.646 844.390 C 433.635 772.068,376.575 718.843,303.995 708.528 C 291.294 706.723,267.835 706.728,255.438 708.538 M626.112 948.581 C 608.335 953.361,593.188 968.661,588.531 986.542 C 585.288 998.993,587.087 1013.715,593.281 1025.418 C 597.399 1033.198,606.802 1042.601,614.582 1046.719 C 627.370 1053.488,606.719 1053.000,880.605 1053.000 C 1124.435 1053.000,1128.901 1052.966,1135.145 1051.036 C 1157.994 1043.976,1172.907 1024.027,1172.974 1000.432 C 1173.003 990.329,1171.432 983.786,1166.749 974.500 C 1162.972 967.009,1153.466 957.560,1145.403 953.281 C 1132.643 946.510,1153.302 946.993,879.540 947.066 C 666.238 947.122,630.745 947.335,626.112 948.581 " stroke="none" fill="currentColor" fill-rule="evenodd"/></svg>
      `,
      cheatsheet: `1. ${locale.olItem}`,
      handler: {
        type: "action",
        shortcut: getShortcutWithPrefix("O", true),
        click({ replaceLines, editor }) {
          replaceLines((line, i) => `${i + 1}. ${line}`);
          editor.focus();
        }
      }
    },
    {
      title: locale.hr,
      icon: `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33337 5.33333C3.33337 3.49238 4.82576 2 6.66671 2H9.33337C11.1743 2 12.6667 3.49238 12.6667 5.33333C12.6667 5.70152 12.3682 6 12 6C11.6319 6 11.3334 5.70152 11.3334 5.33333C11.3334 4.22876 10.4379 3.33333 9.33337 3.33333H6.66671C5.56214 3.33333 4.66671 4.22876 4.66671 5.33333C4.66671 5.70152 4.36823 6 4.00004 6C3.63185 6 3.33337 5.70152 3.33337 5.33333Z" fill="currentColor"></path>
          <path d="M1.33337 8C1.33337 7.63181 1.63185 7.33333 2.00004 7.33333H14C14.3682 7.33333 14.6667 7.63181 14.6667 8C14.6667 8.36819 14.3682 8.66667 14 8.66667H12.0003C12.4187 9.22377 12.6667 9.91626 12.6667 10.6667C12.6667 12.5076 11.1743 14 9.33337 14H6.66671C4.82576 14 3.33337 12.5076 3.33337 10.6667C3.33337 10.2985 3.63185 10 4.00004 10C4.36823 10 4.66671 10.2985 4.66671 10.6667C4.66671 11.7712 5.56214 12.6667 6.66671 12.6667H9.33337C10.4379 12.6667 11.3334 11.7712 11.3334 10.6667C11.3334 9.5621 10.4379 8.66667 9.33337 8.66667H2.00004C1.63185 8.66667 1.33337 8.36819 1.33337 8Z" fill="currentColor"></path>
        </svg>
      `,
      cheatsheet: "---"
    }
  ];
  const rightActions = [];
  plugins.forEach(({ actions }) => {
    if (actions) {
      actions.forEach((action) => {
        if (!action.position || action.position !== "right")
          leftActions.push(action);
        else
          rightActions.unshift(action);
      });
    }
  });
  return {
    leftActions,
    rightActions
  };
}
function create_if_block_1$1(ctx) {
  let span;
  let t_value = ctx[2].limited + "";
  let t;
  return {
    c() {
      span = element("span");
      t = text(t_value);
      attr(span, "class", "bytemd-status-error");
    },
    m(target, anchor) {
      insert(target, span, anchor);
      append(span, t);
    },
    p(ctx2, dirty) {
      if (dirty & 4 && t_value !== (t_value = ctx2[2].limited + ""))
        set_data(t, t_value);
    },
    d(detaching) {
      if (detaching)
        detach(span);
    }
  };
}
function create_if_block$1(ctx) {
  let label;
  let input;
  let t_value = ctx[2].sync + "";
  let t;
  let mounted;
  let dispose;
  return {
    c() {
      label = element("label");
      input = element("input");
      t = text(t_value);
      attr(input, "type", "checkbox");
      input.checked = ctx[1];
    },
    m(target, anchor) {
      insert(target, label, anchor);
      append(label, input);
      append(label, t);
      if (!mounted) {
        dispose = listen(input, "change", ctx[8]);
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (dirty & 2) {
        input.checked = ctx2[1];
      }
      if (dirty & 4 && t_value !== (t_value = ctx2[2].sync + ""))
        set_data(t, t_value);
    },
    d(detaching) {
      if (detaching)
        detach(label);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$2(ctx) {
  let div2;
  let div0;
  let span0;
  let t0_value = ctx[2].words + "";
  let t0;
  let t1;
  let strong0;
  let t2;
  let span1;
  let t3_value = ctx[2].lines + "";
  let t3;
  let t4;
  let strong1;
  let t5;
  let div1;
  let span2;
  let t6_value = ctx[2].top + "";
  let t6;
  let mounted;
  let dispose;
  let if_block0 = ctx[3] && create_if_block_1$1(ctx);
  let if_block1 = ctx[0] && create_if_block$1(ctx);
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      span0 = element("span");
      t0 = text(t0_value);
      t1 = text(": ");
      strong0 = element("strong");
      t2 = text(ctx[5]);
      span1 = element("span");
      t3 = text(t3_value);
      t4 = text(": ");
      strong1 = element("strong");
      t5 = text(ctx[4]);
      if (if_block0)
        if_block0.c();
      div1 = element("div");
      if (if_block1)
        if_block1.c();
      span2 = element("span");
      t6 = text(t6_value);
      attr(div0, "class", "bytemd-status-left");
      attr(div1, "class", "bytemd-status-right");
      attr(div2, "class", "bytemd-status");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div0, span0);
      append(span0, t0);
      append(span0, t1);
      append(span0, strong0);
      append(strong0, t2);
      append(div0, span1);
      append(span1, t3);
      append(span1, t4);
      append(span1, strong1);
      append(strong1, t5);
      if (if_block0)
        if_block0.m(div0, null);
      append(div2, div1);
      if (if_block1)
        if_block1.m(div1, null);
      append(div1, span2);
      append(span2, t6);
      if (!mounted) {
        dispose = listen(span2, "click", ctx[9]);
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (dirty & 4 && t0_value !== (t0_value = ctx2[2].words + ""))
        set_data(t0, t0_value);
      if (dirty & 32)
        set_data(t2, ctx2[5]);
      if (dirty & 4 && t3_value !== (t3_value = ctx2[2].lines + ""))
        set_data(t3, t3_value);
      if (dirty & 16)
        set_data(t5, ctx2[4]);
      if (ctx2[3]) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
        } else {
          if_block0 = create_if_block_1$1(ctx2);
          if_block0.c();
          if_block0.m(div0, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (ctx2[0]) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
        } else {
          if_block1 = create_if_block$1(ctx2);
          if_block1.c();
          if_block1.m(div1, span2);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (dirty & 4 && t6_value !== (t6_value = ctx2[2].top + ""))
        set_data(t6, t6_value);
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(div2);
      if (if_block0)
        if_block0.d();
      if (if_block1)
        if_block1.d();
      mounted = false;
      dispose();
    }
  };
}
function instance$2($$self, $$props, $$invalidate) {
  let words2;
  let lines2;
  let { showSync } = $$props;
  let { value } = $$props;
  let { syncEnabled } = $$props;
  let { locale } = $$props;
  let { islimited } = $$props;
  const dispatch = createEventDispatcher();
  const change_handler = () => dispatch("sync", !syncEnabled);
  const click_handler = () => dispatch("top");
  $$self.$$set = ($$props2) => {
    if ("showSync" in $$props2)
      $$invalidate(0, showSync = $$props2.showSync);
    if ("value" in $$props2)
      $$invalidate(7, value = $$props2.value);
    if ("syncEnabled" in $$props2)
      $$invalidate(1, syncEnabled = $$props2.syncEnabled);
    if ("locale" in $$props2)
      $$invalidate(2, locale = $$props2.locale);
    if ("islimited" in $$props2)
      $$invalidate(3, islimited = $$props2.islimited);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & 128) {
      $$invalidate(5, words2 = wordCount(value));
    }
    if ($$self.$$.dirty & 128) {
      $$invalidate(4, lines2 = value.split("\n").length);
    }
  };
  return [
    showSync,
    syncEnabled,
    locale,
    islimited,
    lines2,
    words2,
    dispatch,
    value,
    change_handler,
    click_handler
  ];
}
class Status extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$2, create_fragment$2, safe_not_equal, {
      showSync: 0,
      value: 7,
      syncEnabled: 1,
      locale: 2,
      islimited: 3
    });
  }
}
function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[22] = list[i];
  child_ctx[24] = i;
  return child_ctx;
}
function get_each_context_1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[22] = list[i];
  child_ctx[24] = i;
  return child_ctx;
}
function create_else_block(ctx) {
  let div0;
  let t0_value = ctx[2].write + "";
  let t0;
  let div1;
  let t1_value = ctx[2].preview + "";
  let t1;
  let mounted;
  let dispose;
  return {
    c() {
      div0 = element("div");
      t0 = text(t0_value);
      div1 = element("div");
      t1 = text(t1_value);
      attr(div0, "class", "bytemd-toolbar-tab");
      toggle_class(div0, "bytemd-toolbar-tab-active", ctx[1] !== "preview");
      attr(div1, "class", "bytemd-toolbar-tab");
      toggle_class(div1, "bytemd-toolbar-tab-active", ctx[1] === "preview");
    },
    m(target, anchor) {
      insert(target, div0, anchor);
      append(div0, t0);
      insert(target, div1, anchor);
      append(div1, t1);
      if (!mounted) {
        dispose = [
          listen(div0, "click", ctx[14]),
          listen(div1, "click", ctx[15])
        ];
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (dirty & 4 && t0_value !== (t0_value = ctx2[2].write + ""))
        set_data(t0, t0_value);
      if (dirty & 2) {
        toggle_class(div0, "bytemd-toolbar-tab-active", ctx2[1] !== "preview");
      }
      if (dirty & 4 && t1_value !== (t1_value = ctx2[2].preview + ""))
        set_data(t1, t1_value);
      if (dirty & 2) {
        toggle_class(div1, "bytemd-toolbar-tab-active", ctx2[1] === "preview");
      }
    },
    d(detaching) {
      if (detaching)
        detach(div0);
      if (detaching)
        detach(div1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_1(ctx) {
  let each_1_anchor;
  let each_value_1 = ctx[3];
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
  }
  return {
    c() {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(target, anchor);
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (dirty & 8) {
        each_value_1 = ctx2[3];
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1(ctx2, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block_1(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value_1.length;
      }
    },
    d(detaching) {
      destroy_each(each_blocks, detaching);
      if (detaching)
        detach(each_1_anchor);
    }
  };
}
function create_if_block_2(ctx) {
  let div;
  let raw_value = ctx[22].icon + "";
  return {
    c() {
      div = element("div");
      attr(div, "class", ["bytemd-toolbar-icon", tippyClass].join(" "));
      attr(div, "bytemd-tippy-path", ctx[24]);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      div.innerHTML = raw_value;
    },
    p(ctx2, dirty) {
      if (dirty & 8 && raw_value !== (raw_value = ctx2[22].icon + ""))
        div.innerHTML = raw_value;
    },
    d(detaching) {
      if (detaching)
        detach(div);
    }
  };
}
function create_each_block_1(ctx) {
  let if_block_anchor;
  let if_block = ctx[22].handler && create_if_block_2(ctx);
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (ctx2[22].handler) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block_2(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_if_block(ctx) {
  let div;
  let raw_value = ctx[22].icon + "";
  return {
    c() {
      div = element("div");
      attr(div, "class", ["bytemd-toolbar-icon", tippyClass, tippyClassRight].join(" "));
      attr(div, "bytemd-tippy-path", ctx[24]);
      toggle_class(div, "bytemd-toolbar-icon-active", ctx[22].active);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      div.innerHTML = raw_value;
    },
    p(ctx2, dirty) {
      if (dirty & 32 && raw_value !== (raw_value = ctx2[22].icon + ""))
        div.innerHTML = raw_value;
      if (dirty & 32) {
        toggle_class(div, "bytemd-toolbar-icon-active", ctx2[22].active);
      }
    },
    d(detaching) {
      if (detaching)
        detach(div);
    }
  };
}
function create_each_block(ctx) {
  let if_block_anchor;
  let if_block = !ctx[22].hidden && create_if_block(ctx);
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, dirty) {
      if (!ctx2[22].hidden) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (if_block)
        if_block.d(detaching);
      if (detaching)
        detach(if_block_anchor);
    }
  };
}
function create_fragment$1(ctx) {
  let div2;
  let div0;
  let div1;
  let mounted;
  let dispose;
  function select_block_type(ctx2, dirty) {
    if (ctx2[0])
      return create_if_block_1;
    return create_else_block;
  }
  let current_block_type = select_block_type(ctx);
  let if_block = current_block_type(ctx);
  let each_value = ctx[5];
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      if_block.c();
      div1 = element("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div0, "class", "bytemd-toolbar-left");
      attr(div1, "class", "bytemd-toolbar-right");
      attr(div2, "class", "bytemd-toolbar");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      if_block.m(div0, null);
      append(div2, div1);
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(div1, null);
      }
      ctx[16](div2);
      if (!mounted) {
        dispose = listen(div2, "click", ctx[7]);
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (current_block_type === (current_block_type = select_block_type(ctx2)) && if_block) {
        if_block.p(ctx2, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx2);
        if (if_block) {
          if_block.c();
          if_block.m(div0, null);
        }
      }
      if (dirty & 32) {
        each_value = ctx2[5];
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div1, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i: noop,
    o: noop,
    d(detaching) {
      if (detaching)
        detach(div2);
      if_block.d();
      destroy_each(each_blocks, detaching);
      ctx[16](null);
      mounted = false;
      dispose();
    }
  };
}
const tippyClass = "bytemd-tippy";
const tippyClassRight = "bytemd-tippy-right";
const tippyPathKey = "bytemd-tippy-path";
function instance$1($$self, $$props, $$invalidate) {
  let writeActive;
  let previewActive;
  let rightActions;
  const dispatch = createEventDispatcher();
  let toolbar;
  let { context } = $$props;
  let { split } = $$props;
  let { activeTab } = $$props;
  let { fullscreen: fullscreen2 } = $$props;
  let { sidebar } = $$props;
  let { locale } = $$props;
  let { actions } = $$props;
  let { rightAfferentActions } = $$props;
  function getPayloadFromElement(e) {
    var _a, _b;
    const paths = (_b = (_a = e.getAttribute(tippyPathKey)) == null ? void 0 : _a.split("-")) == null ? void 0 : _b.map((x) => parseInt(x, 10));
    if (!paths)
      return;
    let item = {
      title: "",
      handler: {
        type: "dropdown",
        actions: e.classList.contains(tippyClassRight) ? rightActions : actions
      }
    };
    paths == null ? void 0 : paths.forEach((index2) => {
      var _a2;
      if (((_a2 = item.handler) == null ? void 0 : _a2.type) === "dropdown") {
        item = item.handler.actions[index2];
      }
    });
    return { paths, item };
  }
  let delegateInstance;
  function init2() {
    delegateInstance = delegate(toolbar, {
      target: `.${tippyClass}`,
      onCreate({ setProps, reference }) {
        const payload = getPayloadFromElement(reference);
        if (!payload)
          return;
        const { item, paths } = payload;
        const { handler } = item;
        if (!handler)
          return;
        if (handler.type === "action") {
          setProps({
            content: item.title,
            onHidden(ins) {
              ins.destroy();
            }
          });
        } else if (handler.type === "dropdown") {
          const dropdown = document.createElement("div");
          dropdown.classList.add("bytemd-dropdown");
          if (item.title) {
            const dropdownTitle = document.createElement("div");
            dropdownTitle.classList.add("bytemd-dropdown-title");
            dropdownTitle.appendChild(document.createTextNode(item.title));
            dropdown.appendChild(dropdownTitle);
          }
          handler.actions.forEach((subAction, i) => {
            var _a;
            const dropdownItem = document.createElement("div");
            dropdownItem.classList.add("bytemd-dropdown-item");
            dropdownItem.setAttribute(tippyPathKey, [...paths, i].join("-"));
            if (((_a = subAction.handler) == null ? void 0 : _a.type) === "dropdown") {
              dropdownItem.classList.add(tippyClass);
            }
            if (reference.classList.contains(tippyClassRight)) {
              dropdownItem.classList.add(tippyClassRight);
            }
            dropdownItem.innerHTML = `${subAction.icon ? `<div class="bytemd-dropdown-item-icon">${subAction.icon}</div>` : ""}<div class="bytemd-dropdown-item-title">${subAction.title}</div>`;
            dropdown.appendChild(dropdownItem);
          });
          setProps({
            allowHTML: true,
            showOnCreate: true,
            theme: "light-border",
            placement: "bottom-start",
            interactive: true,
            interactiveDebounce: 50,
            arrow: false,
            offset: [0, 4],
            content: dropdown.outerHTML,
            onHidden(ins) {
              ins.destroy();
            },
            onCreate(ins) {
              [...ins.popper.querySelectorAll(".bytemd-dropdown-item")].forEach((el, i) => {
                var _a;
                const actionHandler = (_a = handler.actions[i]) == null ? void 0 : _a.handler;
                if ((actionHandler == null ? void 0 : actionHandler.type) === "action") {
                  const { mouseenter, mouseleave } = actionHandler;
                  if (mouseenter) {
                    el.addEventListener("mouseenter", () => {
                      mouseenter(context);
                    });
                  }
                  if (mouseleave) {
                    el.addEventListener("mouseleave", () => {
                      mouseleave(context);
                    });
                  }
                }
              });
            }
          });
        }
      }
    });
  }
  onMount(() => {
    init2();
  });
  function handleClick(e) {
    var _a, _b;
    const target = e.target.closest(`[${tippyPathKey}]`);
    if (!target)
      return;
    const handler = (_b = (_a = getPayloadFromElement(target)) == null ? void 0 : _a.item) == null ? void 0 : _b.handler;
    if ((handler == null ? void 0 : handler.type) === "action") {
      handler.click(context);
    }
    delegateInstance == null ? void 0 : delegateInstance.destroy();
    init2();
  }
  const click_handler = () => dispatch("tab", "write");
  const click_handler_1 = () => dispatch("tab", "preview");
  function div2_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      toolbar = $$value;
      $$invalidate(4, toolbar);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("context" in $$props2)
      $$invalidate(8, context = $$props2.context);
    if ("split" in $$props2)
      $$invalidate(0, split = $$props2.split);
    if ("activeTab" in $$props2)
      $$invalidate(1, activeTab = $$props2.activeTab);
    if ("fullscreen" in $$props2)
      $$invalidate(9, fullscreen2 = $$props2.fullscreen);
    if ("sidebar" in $$props2)
      $$invalidate(10, sidebar = $$props2.sidebar);
    if ("locale" in $$props2)
      $$invalidate(2, locale = $$props2.locale);
    if ("actions" in $$props2)
      $$invalidate(3, actions = $$props2.actions);
    if ("rightAfferentActions" in $$props2)
      $$invalidate(11, rightAfferentActions = $$props2.rightAfferentActions);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & 1024)
      ;
    if ($$self.$$.dirty & 1024)
      ;
    if ($$self.$$.dirty & 2) {
      $$invalidate(13, writeActive = activeTab === "write");
    }
    if ($$self.$$.dirty & 2) {
      $$invalidate(12, previewActive = activeTab === "preview");
    }
    if ($$self.$$.dirty & 14341) {
      $$invalidate(5, rightActions = [
        {
          title: writeActive ? locale.exitWriteOnly : locale.writeOnly,
          icon: `
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6666 2.66659C11.0348 2.66659 11.3333 2.96506 11.3333 3.33325L11.3333 10.6666C11.3333 11.0348 11.0348 11.3333 10.6666 11.3333C10.2984 11.3333 9.99992 11.0348 9.99992 10.6666V3.33325C9.99992 2.96506 10.2984 2.66659 10.6666 2.66659Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M4.17239 0.333252H9.82745C10.3641 0.333244 10.807 0.333237 11.1678 0.362715C11.5425 0.393332 11.887 0.459041 12.2106 0.623902C12.7123 0.879564 13.1203 1.28751 13.3759 1.78928C13.5408 2.11283 13.6065 2.4573 13.6371 2.83204C13.6666 3.19283 13.6666 3.63573 13.6666 4.17237V9.82747C13.6666 10.3641 13.6666 10.807 13.6371 11.1678C13.6065 11.5425 13.5408 11.887 13.3759 12.2106C13.1203 12.7123 12.7123 13.1203 12.2106 13.3759C11.887 13.5408 11.5425 13.6065 11.1678 13.6371C10.807 13.6666 10.3641 13.6666 9.82747 13.6666H4.17237C3.63573 13.6666 3.19283 13.6666 2.83204 13.6371C2.4573 13.6065 2.11283 13.5408 1.78928 13.3759C1.28751 13.1203 0.879564 12.7123 0.623902 12.2106C0.459041 11.887 0.393332 11.5425 0.362715 11.1678C0.333237 10.807 0.333244 10.3641 0.333252 9.82745V4.17239C0.333244 3.63574 0.333237 3.19283 0.362715 2.83204C0.393332 2.4573 0.459041 2.11283 0.623902 1.78928C0.879564 1.28751 1.28751 0.879564 1.78928 0.623902C2.11283 0.459041 2.4573 0.393332 2.83204 0.362715C3.19283 0.333237 3.63574 0.333244 4.17239 0.333252ZM2.94061 1.69162C2.64833 1.7155 2.49887 1.75878 2.3946 1.81191C2.14372 1.93974 1.93974 2.14372 1.81191 2.3946C1.75878 2.49887 1.7155 2.64833 1.69162 2.94061C1.6671 3.24067 1.66659 3.62887 1.66659 4.19992V9.79992C1.66659 10.371 1.6671 10.7592 1.69162 11.0592C1.7155 11.3515 1.75878 11.501 1.81191 11.6052C1.93974 11.8561 2.14372 12.0601 2.3946 12.1879C2.49887 12.2411 2.64833 12.2843 2.94061 12.3082C3.24067 12.3327 3.62887 12.3333 4.19992 12.3333H9.79992C10.371 12.3333 10.7592 12.3327 11.0592 12.3082C11.3515 12.2843 11.501 12.2411 11.6052 12.1879C11.8561 12.0601 12.0601 11.8561 12.1879 11.6052C12.2411 11.501 12.2843 11.3515 12.3082 11.0592C12.3327 10.7592 12.3333 10.371 12.3333 9.79992V4.19992C12.3333 3.62887 12.3327 3.24067 12.3082 2.94061C12.2843 2.64833 12.2411 2.49887 12.1879 2.3946C12.0601 2.14372 11.8561 1.93974 11.6052 1.81191C11.501 1.75878 11.3515 1.7155 11.0592 1.69162C10.7592 1.6671 10.371 1.66659 9.79992 1.66659H4.19992C3.62887 1.66659 3.24067 1.6671 2.94061 1.69162Z" fill="currentColor" /></svg>
      `,
          handler: {
            type: "action",
            click() {
              dispatch("tab", "write");
            }
          },
          active: writeActive,
          hidden: !split
        },
        {
          title: previewActive ? locale.exitPreviewOnly : locale.previewOnly,
          icon: `
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33325 2.66659C3.70144 2.66659 3.99992 2.96506 3.99992 3.33325L3.99992 10.6666C3.99992 11.0348 3.70144 11.3333 3.33325 11.3333C2.96506 11.3333 2.66659 11.0348 2.66659 10.6666L2.66659 3.33325C2.66659 2.96506 2.96506 2.66659 3.33325 2.66659Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M4.17239 0.333252H9.82745C10.3641 0.333244 10.807 0.333237 11.1678 0.362715C11.5425 0.393332 11.887 0.459041 12.2106 0.623902C12.7123 0.879564 13.1203 1.28751 13.3759 1.78928C13.5408 2.11283 13.6065 2.4573 13.6371 2.83204C13.6666 3.19283 13.6666 3.63573 13.6666 4.17237V9.82747C13.6666 10.3641 13.6666 10.807 13.6371 11.1678C13.6065 11.5425 13.5408 11.887 13.3759 12.2106C13.1203 12.7123 12.7123 13.1203 12.2106 13.3759C11.887 13.5408 11.5425 13.6065 11.1678 13.6371C10.807 13.6666 10.3641 13.6666 9.82747 13.6666H4.17237C3.63573 13.6666 3.19283 13.6666 2.83204 13.6371C2.4573 13.6065 2.11283 13.5408 1.78928 13.3759C1.28751 13.1203 0.879564 12.7123 0.623902 12.2106C0.459041 11.887 0.393332 11.5425 0.362715 11.1678C0.333237 10.807 0.333244 10.3641 0.333252 9.82745V4.17239C0.333244 3.63574 0.333237 3.19283 0.362715 2.83204C0.393332 2.4573 0.459041 2.11283 0.623902 1.78928C0.879564 1.28751 1.28751 0.879564 1.78928 0.623902C2.11283 0.459041 2.4573 0.393332 2.83204 0.362715C3.19283 0.333237 3.63574 0.333244 4.17239 0.333252ZM2.94061 1.69162C2.64833 1.7155 2.49887 1.75878 2.3946 1.81191C2.14372 1.93974 1.93974 2.14372 1.81191 2.3946C1.75878 2.49887 1.7155 2.64833 1.69162 2.94061C1.6671 3.24067 1.66659 3.62887 1.66659 4.19992V9.79992C1.66659 10.371 1.6671 10.7592 1.69162 11.0592C1.7155 11.3515 1.75878 11.501 1.81191 11.6052C1.93974 11.8561 2.14372 12.0601 2.3946 12.1879C2.49887 12.2411 2.64833 12.2843 2.94061 12.3082C3.24067 12.3327 3.62887 12.3333 4.19992 12.3333H9.79992C10.371 12.3333 10.7592 12.3327 11.0592 12.3082C11.3515 12.2843 11.501 12.2411 11.6052 12.1879C11.8561 12.0601 12.0601 11.8561 12.1879 11.6052C12.2411 11.501 12.2843 11.3515 12.3082 11.0592C12.3327 10.7592 12.3333 10.371 12.3333 9.79992V4.19992C12.3333 3.62887 12.3327 3.24067 12.3082 2.94061C12.2843 2.64833 12.2411 2.49887 12.1879 2.3946C12.0601 2.14372 11.8561 1.93974 11.6052 1.81191C11.501 1.75878 11.3515 1.7155 11.0592 1.69162C10.7592 1.6671 10.371 1.66659 9.79992 1.66659H4.19992C3.62887 1.66659 3.24067 1.6671 2.94061 1.69162Z" fill="currentColor" /></svg>
      `,
          handler: {
            type: "action",
            click() {
              dispatch("tab", "preview");
            }
          },
          active: previewActive,
          hidden: !split
        },
        ...rightAfferentActions
      ]);
    }
  };
  return [
    split,
    activeTab,
    locale,
    actions,
    toolbar,
    rightActions,
    dispatch,
    handleClick,
    context,
    fullscreen2,
    sidebar,
    rightAfferentActions,
    previewActive,
    writeActive,
    click_handler,
    click_handler_1,
    div2_binding
  ];
}
class Toolbar extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1, create_fragment$1, not_equal, {
      context: 8,
      split: 0,
      activeTab: 1,
      fullscreen: 9,
      sidebar: 10,
      locale: 2,
      actions: 3,
      rightAfferentActions: 11
    });
  }
}
function create_fragment(ctx) {
  let div5;
  let toolbar;
  let div4;
  let div0;
  let div0_style_value;
  let div1;
  let div1_style_value;
  let div3;
  let div2;
  let status;
  let current;
  let mounted;
  let dispose;
  toolbar = new Toolbar({
    props: {
      context: ctx[7],
      split: ctx[8],
      activeTab: ctx[5],
      sidebar: ctx[6],
      fullscreen: ctx[12],
      rightAfferentActions: ctx[15].rightActions,
      locale: ctx[9],
      actions: ctx[15].leftActions
    }
  });
  toolbar.$on("key", ctx[26]);
  toolbar.$on("tab", ctx[27]);
  toolbar.$on("click", ctx[28]);
  status = new Status({
    props: {
      locale: ctx[9],
      showSync: !ctx[1] && ctx[8],
      value: ctx[13],
      syncEnabled: ctx[14],
      islimited: ctx[0].length > ctx[2]
    }
  });
  status.$on("sync", ctx[32]);
  status.$on("top", ctx[33]);
  return {
    c() {
      div5 = element("div");
      create_component(toolbar.$$.fragment);
      div4 = element("div");
      div0 = element("div");
      div1 = element("div");
      div3 = element("div");
      div2 = element("div");
      div2.innerHTML = `<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8L40 40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8 40L40 8" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
      create_component(status.$$.fragment);
      attr(div0, "class", "bytemd-editor");
      attr(div0, "style", div0_style_value = ctx[16].edit);
      attr(div1, "class", "bytemd-preview");
      attr(div1, "style", div1_style_value = ctx[16].preview);
      attr(div2, "class", "bytemd-sidebar-close");
      attr(div3, "class", "bytemd-sidebar");
      toggle_class(div3, "bytemd-hidden", ctx[6] === false);
      attr(div4, "class", "bytemd-body");
      attr(div5, "class", "bytemd");
      toggle_class(div5, "bytemd-split", ctx[8] && ctx[5] === false);
      toggle_class(div5, "bytemd-fullscreen", ctx[12]);
    },
    m(target, anchor) {
      insert(target, div5, anchor);
      mount_component(toolbar, div5, null);
      append(div5, div4);
      append(div4, div0);
      ctx[29](div0);
      append(div4, div1);
      ctx[30](div1);
      append(div4, div3);
      append(div3, div2);
      mount_component(status, div5, null);
      ctx[34](div5);
      current = true;
      if (!mounted) {
        dispose = listen(div2, "click", ctx[31]);
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      const toolbar_changes = {};
      if (dirty[0] & 128)
        toolbar_changes.context = ctx2[7];
      if (dirty[0] & 256)
        toolbar_changes.split = ctx2[8];
      if (dirty[0] & 32)
        toolbar_changes.activeTab = ctx2[5];
      if (dirty[0] & 64)
        toolbar_changes.sidebar = ctx2[6];
      if (dirty[0] & 4096)
        toolbar_changes.fullscreen = ctx2[12];
      if (dirty[0] & 32768)
        toolbar_changes.rightAfferentActions = ctx2[15].rightActions;
      if (dirty[0] & 512)
        toolbar_changes.locale = ctx2[9];
      if (dirty[0] & 32768)
        toolbar_changes.actions = ctx2[15].leftActions;
      toolbar.$set(toolbar_changes);
      if (!current || dirty[0] & 65536 && div0_style_value !== (div0_style_value = ctx2[16].edit)) {
        attr(div0, "style", div0_style_value);
      }
      if (!current || dirty[0] & 65536 && div1_style_value !== (div1_style_value = ctx2[16].preview)) {
        attr(div1, "style", div1_style_value);
      }
      if (!current || dirty[0] & 64) {
        toggle_class(div3, "bytemd-hidden", ctx2[6] === false);
      }
      const status_changes = {};
      if (dirty[0] & 512)
        status_changes.locale = ctx2[9];
      if (dirty[0] & 258)
        status_changes.showSync = !ctx2[1] && ctx2[8];
      if (dirty[0] & 8192)
        status_changes.value = ctx2[13];
      if (dirty[0] & 16384)
        status_changes.syncEnabled = ctx2[14];
      if (dirty[0] & 5)
        status_changes.islimited = ctx2[0].length > ctx2[2];
      status.$set(status_changes);
      if (!current || dirty[0] & 288) {
        toggle_class(div5, "bytemd-split", ctx2[8] && ctx2[5] === false);
      }
      if (!current || dirty[0] & 4096) {
        toggle_class(div5, "bytemd-fullscreen", ctx2[12]);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(toolbar.$$.fragment, local);
      transition_in(status.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(toolbar.$$.fragment, local);
      transition_out(status.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching)
        detach(div5);
      destroy_component(toolbar);
      ctx[29](null);
      ctx[30](null);
      destroy_component(status);
      ctx[34](null);
      mounted = false;
      dispose();
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let mergedLocale;
  let actions;
  let split;
  let styles;
  let context;
  let { value = "" } = $$props;
  let { plugins = [] } = $$props;
  let { mode = "auto" } = $$props;
  let { previewDebounce = 300 } = $$props;
  let { placeholder = void 0 } = $$props;
  let { editorConfig = void 0 } = $$props;
  let { locale = void 0 } = $$props;
  let { uploadImages = void 0 } = $$props;
  let { overridePreview = void 0 } = $$props;
  let { maxLength = Infinity } = $$props;
  const dispatch = createEventDispatcher();
  let root;
  let editorEl;
  let previewEl;
  let containerWidth = Infinity;
  let codemirror;
  let editor;
  let activeTab;
  let fullscreen2 = false;
  let sidebar = false;
  let cbs = [];
  let keyMap = {};
  function on() {
    cbs = plugins.map((p) => {
      var _a;
      return (_a = p.editorEffect) == null ? void 0 : _a.call(p, context);
    });
    keyMap = {};
    actions.leftActions.forEach(({ handler }) => {
      if ((handler == null ? void 0 : handler.type) === "action" && handler.shortcut) {
        keyMap[handler.shortcut] = () => {
          handler.click(context);
        };
      }
    });
    editor.addKeyMap(keyMap);
  }
  function off() {
    cbs.forEach((cb) => cb && cb());
    editor == null ? void 0 : editor.removeKeyMap(keyMap);
  }
  let debouncedValue = value;
  const setDebouncedValue = debounce(
    (value2) => {
      $$invalidate(13, debouncedValue = value2);
      overridePreview == null ? void 0 : overridePreview(previewEl, { value: debouncedValue });
    },
    previewDebounce
  );
  let syncEnabled = true;
  let editCalled = false;
  let previewCalled = false;
  let editPs;
  let previewPs;
  onMount(async () => {
    $$invalidate(25, codemirror = createCodeMirror());
    $$invalidate(4, editor = codemirror(editorEl, {
      value,
      mode: "yaml-frontmatter",
      lineWrapping: true,
      tabSize: 8,
      indentUnit: 4,
      extraKeys: {
        Enter: "newlineAndIndentContinueMarkdownList"
      },
      ...editorConfig,
      placeholder
    }));
    editor.addKeyMap({
      Tab: "indentMore",
      "Shift-Tab": "indentLess"
    });
    editor.on("change", () => {
      dispatch("change", { value: editor.getValue() });
    });
    const editorScrollHandler = () => {
      if (overridePreview)
        return;
      if (!syncEnabled)
        return;
      if (previewCalled) {
        previewCalled = false;
        return;
      }
      const info = editor.getScrollInfo();
      const leftRatio = info.top / (info.height - info.clientHeight);
      const startIndex = findStartIndex(leftRatio, editPs);
      const rightRatio = (leftRatio - editPs[startIndex]) * (previewPs[startIndex + 1] - previewPs[startIndex]) / (editPs[startIndex + 1] - editPs[startIndex]) + previewPs[startIndex];
      previewEl.scrollTo(0, rightRatio * (previewEl.scrollHeight - previewEl.clientHeight));
      editCalled = true;
    };
    const previewScrollHandler = () => {
      if (overridePreview)
        return;
      findStartIndex(previewEl.scrollTop / (previewEl.scrollHeight - previewEl.offsetHeight), previewPs);
      if (!syncEnabled)
        return;
      if (editCalled) {
        editCalled = false;
        return;
      }
      const rightRatio = previewEl.scrollTop / (previewEl.scrollHeight - previewEl.clientHeight);
      const startIndex = findStartIndex(rightRatio, previewPs);
      const leftRatio = (rightRatio - previewPs[startIndex]) * (editPs[startIndex + 1] - editPs[startIndex]) / (previewPs[startIndex + 1] - previewPs[startIndex]) + editPs[startIndex];
      if (isNaN(leftRatio)) {
        return;
      }
      const info = editor.getScrollInfo();
      editor.scrollTo(0, leftRatio * (info.height - info.clientHeight));
      previewCalled = true;
    };
    editor.on("scroll", editorScrollHandler);
    previewEl.addEventListener("scroll", previewScrollHandler, { passive: true });
    const handleImages = async (e, itemList) => {
      if (!uploadImages)
        return;
      const files = Array.from(itemList != null ? itemList : []).map((item) => {
        if (item.type.startsWith("image/")) {
          return item.getAsFile();
        }
      }).filter((f) => f != null);
      if (files.length) {
        e.preventDefault();
        await handleImageUpload(context, uploadImages, files);
      }
    };
    editor.on("drop", async (_, e) => {
      var _a;
      handleImages(e, (_a = e.dataTransfer) == null ? void 0 : _a.items);
    });
    editor.on("paste", async (_, e) => {
      var _a;
      handleImages(e, (_a = e.clipboardData) == null ? void 0 : _a.items);
    });
    new ResizeObserver((entries) => {
      $$invalidate(24, containerWidth = entries[0].contentRect.width);
    }).observe(root, {
      box: "border-box"
    });
  });
  onDestroy(off);
  const key_handler = (e) => {
    editor.setOption("keyMap", e.detail);
    editor.focus();
  };
  const tab_handler = (e) => {
    const v = e.detail;
    if (split) {
      $$invalidate(5, activeTab = activeTab === v ? false : v);
    } else {
      $$invalidate(5, activeTab = v);
    }
    if (activeTab === "write") {
      tick().then(() => {
        editor && editor.focus();
      });
    }
  };
  const click_handler = (e) => {
    switch (e.detail) {
      case "fullscreen":
        $$invalidate(12, fullscreen2 = !fullscreen2);
        break;
      case "help":
        $$invalidate(6, sidebar = sidebar === "help" ? false : "help");
        break;
    }
  };
  function div0_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      editorEl = $$value;
      $$invalidate(10, editorEl);
    });
  }
  function div1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      previewEl = $$value;
      $$invalidate(11, previewEl);
    });
  }
  const click_handler_1 = () => {
    $$invalidate(6, sidebar = false);
  };
  const sync_handler = (e) => {
    $$invalidate(14, syncEnabled = e.detail);
  };
  const top_handler = () => {
    editor.scrollTo(null, 0);
    previewEl.scrollTo({ top: 0 });
  };
  function div5_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      root = $$value;
      $$invalidate(3, root);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("value" in $$props2)
      $$invalidate(0, value = $$props2.value);
    if ("plugins" in $$props2)
      $$invalidate(17, plugins = $$props2.plugins);
    if ("mode" in $$props2)
      $$invalidate(18, mode = $$props2.mode);
    if ("previewDebounce" in $$props2)
      $$invalidate(19, previewDebounce = $$props2.previewDebounce);
    if ("placeholder" in $$props2)
      $$invalidate(20, placeholder = $$props2.placeholder);
    if ("editorConfig" in $$props2)
      $$invalidate(21, editorConfig = $$props2.editorConfig);
    if ("locale" in $$props2)
      $$invalidate(22, locale = $$props2.locale);
    if ("uploadImages" in $$props2)
      $$invalidate(23, uploadImages = $$props2.uploadImages);
    if ("overridePreview" in $$props2)
      $$invalidate(1, overridePreview = $$props2.overridePreview);
    if ("maxLength" in $$props2)
      $$invalidate(2, maxLength = $$props2.maxLength);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & 4194304) {
      $$invalidate(9, mergedLocale = { ...en, ...locale });
    }
    if ($$self.$$.dirty[0] & 8520192) {
      $$invalidate(15, actions = getBuiltinActions(mergedLocale, plugins, uploadImages));
    }
    if ($$self.$$.dirty[0] & 17039360) {
      $$invalidate(8, split = mode === "split" || mode === "auto" && containerWidth >= 900);
    }
    if ($$self.$$.dirty[0] & 256) {
      ((_) => {
        if (split)
          $$invalidate(5, activeTab = false);
      })();
    }
    if ($$self.$$.dirty[0] & 352) {
      $$invalidate(16, styles = (() => {
        let edit;
        let preview2;
        if (split && activeTab === false) {
          if (sidebar) {
            edit = `width:calc(50% - ${sidebar ? 140 : 0}px)`;
            preview2 = `width:calc(50% - ${sidebar ? 140 : 0}px)`;
          } else {
            edit = "width:50%";
            preview2 = "width:50%";
          }
        } else if (activeTab === "preview") {
          edit = "display:none";
          preview2 = `width:calc(100% - ${sidebar ? 280 : 0}px)`;
        } else {
          edit = `width:calc(100% - ${sidebar ? 280 : 0}px)`;
          preview2 = "display:none";
        }
        return { edit, preview: preview2 };
      })());
    }
    if ($$self.$$.dirty[0] & 33554456) {
      $$invalidate(7, context = (() => {
        const context2 = {
          codemirror,
          editor,
          root,
          ...createEditorUtils(codemirror, editor)
        };
        return context2;
      })());
    }
    if ($$self.$$.dirty[0] & 1) {
      setDebouncedValue(value);
    }
    if ($$self.$$.dirty[0] & 17) {
      if (editor && value !== editor.getValue()) {
        editor.setValue(value);
      }
    }
    if ($$self.$$.dirty[0] & 131088) {
      if (editor && plugins) {
        off();
        tick().then(() => {
          on();
        });
      }
    }
  };
  return [
    value,
    overridePreview,
    maxLength,
    root,
    editor,
    activeTab,
    sidebar,
    context,
    split,
    mergedLocale,
    editorEl,
    previewEl,
    fullscreen2,
    debouncedValue,
    syncEnabled,
    actions,
    styles,
    plugins,
    mode,
    previewDebounce,
    placeholder,
    editorConfig,
    locale,
    uploadImages,
    containerWidth,
    codemirror,
    key_handler,
    tab_handler,
    click_handler,
    div0_binding,
    div1_binding,
    click_handler_1,
    sync_handler,
    top_handler,
    div5_binding
  ];
}
class Editor extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance,
      create_fragment,
      not_equal,
      {
        value: 0,
        plugins: 17,
        mode: 18,
        previewDebounce: 19,
        placeholder: 20,
        editorConfig: 21,
        locale: 22,
        uploadImages: 23,
        overridePreview: 1,
        maxLength: 2
      },
      null,
      [-1, -1]
    );
  }
}
export {
  Editor
};
